import { Component, OnInit } from '@angular/core';
import moment from 'moment-timezone';
import environment from '../../../../environments/environment';
import { LegFiJwtService } from '../../../services/auth/legfi-jwt.service';
import { SignupTargets } from '../../../enums/signup-targets.enum';
import { ScrollService } from '../../../services/scroll.service';

@Component({
    selector: 'app-sign-up',
    templateUrl: './sign-up.component.html',
    styleUrls: ['../auth-layout-shared-styles.scss'],
})
export class SignUpComponent implements OnInit
{
    signupFormTypes = SignupTargets;

    readonly environment = environment;
    readonly payHoaLogo = '/assets/images/payhoa/hoa-management-software/payhoa-logo.svg';
    readonly payHoaLink = 'https://www.payhoa.com';
    readonly year = moment().year();

    constructor(
            private _scrollService: ScrollService,
    ) {
    }

    ngOnInit() {
        if (LegFiJwtService.raw() === 'false') {
            LegFiJwtService.clear();
        }

        this._scrollService.scrollToTop();
    }
}
